const features = [
  {
    icon: 'ri-headphone-line',
    title: 'Expert DJ & Emcee',
    desc: 'Over 20 years reading crowds and keeping dance floors packed. From first dance to last song, every moment is perfectly curated.',
  },
  {
    icon: 'ri-music-2-line',
    title: 'Any Genre, Any Vibe',
    desc: 'Top 40, hip-hop, R&B, country, oldies, Latin — we play what your crowd loves and adapt in real time to keep the energy right.',
  },
  {
    icon: 'ri-camera-line',
    title: 'Photo Booths & Add-Ons',
    desc: 'Elevate your event with fun photo booth experiences, karaoke setups, and interactive game shows that guests never forget.',
  },
  {
    icon: 'ri-expand-diagonal-line',
    title: 'Any Event Size',
    desc: 'From intimate 30-person gatherings to 1,000+ guest productions — we scale our setup and energy to match your event perfectly.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Fully Insured & Professional',
    desc: 'Fully insured, punctual, and backed by 140+ five-star reviews. We show up prepared, on time, and ready to deliver.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Personalized Planning',
    desc: 'We work with you before the event to build a custom playlist, timeline, and flow — so your event feels uniquely yours.',
  },
];

export default function WhyChooseSection() {
  return (
    <section className="relative py-28 md:py-36 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b6cca4a75cfd8efc9ae1d44f2889264f.jpg"
          alt="DJ performing at a live event"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#080808]/92"></div>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_70%_60%_at_30%_50%,_#D4AF3704_0%,_transparent_70%)]"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header row */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-px bg-[#D4AF37]"></div>
              <span className="text-[#D4AF37] text-xs tracking-[0.35em] uppercase font-semibold">Why Bugsie</span>
            </div>
            <h2
              className="text-4xl md:text-5xl font-black text-white leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Built for<br />
              <em className="text-[#D4AF37] not-italic">Unforgettable</em> Events
            </h2>
          </div>
          <p className="text-gray-500 text-base leading-relaxed max-w-sm lg:text-right">
            We don't just play music — we create experiences. Every event is personal, every performance is intentional.
          </p>
        </div>

        {/* Feature grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {features.map((f, idx) => (
            <div
              key={f.title}
              className="group flex gap-4 bg-[#0F0F0F]/80 border border-white/6 rounded-xl p-6 hover:border-[#D4AF37]/35 hover:bg-[#111111]/90 transition-all duration-400 cursor-default"
              style={{ transitionDelay: `${idx * 50}ms` }}
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-[#D4AF37]/8 border border-[#D4AF37]/15 flex-shrink-0 group-hover:bg-[#D4AF37]/15 group-hover:border-[#D4AF37]/30 transition-all duration-300">
                <i className={`${f.icon} text-[#D4AF37] text-xl`}></i>
              </div>
              <div>
                <h3 className="text-white font-semibold text-sm mb-1.5 group-hover:text-[#D4AF37] transition-colors duration-300 tracking-wide">
                  {f.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom accent tags */}
        <div className="mt-14 flex flex-wrap items-center justify-center gap-3">
          {['DJ & Emcee', 'Photo Booths', 'Karaoke', 'Game Shows', 'Weddings', 'Corporate'].map(tag => (
            <span
              key={tag}
              className="bg-[#D4AF37]/8 border border-[#D4AF37]/20 text-[#D4AF37] text-xs px-5 py-2 rounded-full tracking-widest uppercase font-medium"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
